import Vue from 'vue'
import Page from '@/components/pdf-pages/td'
import sharedInjectedCss from '!!raw-loader!@/components/pdf-pages/css/_shared.css'
import { createPdfPage } from '@/utils/pdf-helpers'

export const generateTd = async ({ rfq2, rfq3, repairReport, replacementParts, content, translate }) => {
  const el = document.createElement('div')

  return new Promise((resolve, reject) => {
    return new Vue({
      el,
      template: `
        <page
          :translate="translate"
          :rfq2="rfq2"
          :rfq3="rfq3"
          :repairReport="repairReport"
          :replacementParts="replacementParts"
          :content="content"
        />
        `,
      components: {
        'page': Page
      },
      data: () => ({
        rfq2,
        rfq3,
        repairReport,
        replacementParts,
        content
      }),
      methods: {
        translate
      },
      mounted () {
        resolve(createPdfPage({ injectedCss: [sharedInjectedCss], element: this.$el }))
      },
      errorCaptured (err, vm, info) {
        reject(err)
      }
    })
  })
}
